import React from 'react'
import './Login.scss';
import PFLogo from '../../assets/images/PFLogo.png';
import Representative from '../../assets/images/Representative.svg';
import Employee from '../../assets/images/Employee.svg';
import salesEngineer from '../../assets/images/salesEngineer.png';
import RepresentativeLogin from '../../components/Auth/RepresentativeLogin';
import EmployeeLogin from '../../components/Auth/EmployeeLogin';

const Login = () => {
    return (
        <div>
            {/* <div className='container-fluid'> */}
            <header>
                <div className="container-fluid login-sec">
                    <div className='row'>
                        <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pl-5 pr-5'>
                            <div className='login-screen ml-auto'>
                                <div className="logo-area">
                                    <img src={PFLogo}></img>
                                    <h1 className='mt-3'>Welcome Back! </h1>
                                </div>
                                <div className='select-role'>
                                    <RepresentativeLogin />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            {/* </div> */}
        </div>
    )
}

export default Login